import type { PageCode } from '@gov-nx/module/page/definitions/codes';
import { useCmsStorePage } from '@gov-nx/store/cms/store';

export interface CmsPageProps {
	code: PageCode;
}

export const useCmsPage = (props: CmsPageProps) => useCmsStorePage(props.code);
